import { httpClient } from "@services/api/httpClient";


export async function getOfferTechnicalAssesmentQuestions(offerId: number | string) {
  const response = await httpClient.get("/offer-technical-assesment/questions", {
    params: { offerId }
  });
  return response.data;
}